<template>
	<div class="container-md mh-100">
		<LayoutHeaderSection>
			<template #title>
				<LayoutTextSection :text="(goal_period_id) ? 'Editar período' : 'Crear período'" :breadcrumb="true" />
			</template>
		</LayoutHeaderSection>
		<main class="pt-8 vstack gap-10">
			<CommonFormWrapper submitText="Guardar" :cancelUrl="{ name: 'company.admin.goal.period.index' }" :submitting="submitting" :errors="validationExternal" @submit="submit" v-if="!loading">
				<template #body>
					<CommonFormInputText v-model="target.name" title="Nombre" placeholder="Ingrese un nombre" :validation="validation.name" />
					<div class="vstack gap-2">
						<CommonFormInputDateRange v-model:from="target.start_date" v-model:to="target.end_date" title="Rango de fechas" placeholder="Seleccionar fechas" :showPresetDates="false" />
						<CommonMessageInfo info="Se trata de un período anterior a la fecha actual, una vez procesado no podrá ser modificado." v-if="isBefore" />
					</div>
					<CommonFormInputCustomGoalPeriodUser v-model="target.users" :levels="goal.levels" title="Metas por vendedores" />
				</template>
			</CommonFormWrapper>
		</main>
	</div>
</template>

<script>
	import { ref, reactive, computed, onBeforeMount } from 'vue';
	import router from '@/router';
	import _ from 'lodash';
	import moment from 'moment';
	import useVuelidate from '@vuelidate/core';
	import { required, minLength, maxLength } from '@/helpers/i18n/validators';
	import composableForm from '@/composables/form';
	import CompanyAdminUserRepository from '@/repositories/modules/Company/Admin/User';
	import CompanyAdminGoalRepository from '@/repositories/modules/Company/Admin/Goal';
	import CompanyAdminGoalPeriodRepository from '@/repositories/modules/Company/Admin/GoalPeriod';

	export default {
		props: {
			id: String,
			goal_period_id: String
		},
		setup(props) {
			const { loading, submitting, validationExternal, catchError } = composableForm();
			const goal = ref({});

			const isBefore = computed(() => {
				if(!target.end_date) return false;
				else return moment(target.end_date).isBefore(moment());
			})

			const target = reactive({
				id: null,
				name: null,
				start_date: null,
				end_date: null,
				users: []
			});

			const validation = useVuelidate({
				name: {
					required,
					minLength: minLength(3),
					maxLength: maxLength(150)
				}
			}, target);

			const submit = async () => {
				if(submitting.value) return;
				validationExternal.value = [];
				if(!await validation.value.$validate()) return;

				submitting.value = true;

				if(props.goal_period_id != undefined) {
					await CompanyAdminGoalPeriodRepository.update(props.id, props.goal_period_id, target).then(() => {
						router.push({ name: `company.admin.goal.period.index` });
					}).catch(catchError);
				}else{
					await CompanyAdminGoalPeriodRepository.store(props.id, target).then(() => {
						router.push({ name: `company.admin.goal.period.index` });
					}).catch(catchError);
				}

				submitting.value = false;
			}

			onBeforeMount(async () => {
				try {
					const [ goalResponse, goalPeriodResponse, goalPeriodCopyResponse ] = await Promise.all([
						CompanyAdminGoalRepository.show(props.id),
						(props.goal_period_id != undefined) ? CompanyAdminGoalPeriodRepository.show(props.id, props.goal_period_id) : null,
						(props.goal_period_id == undefined) ? CompanyAdminGoalPeriodRepository.copy(props.id) : null
					]);

					if(goalResponse?.data !== undefined) {
						Object.assign(goal.value, goalResponse.data);
					}

					if(goalPeriodResponse?.data !== undefined) {
						Object.assign(target, goalPeriodResponse.data);
					}

					if(goalPeriodCopyResponse?.data !== undefined) {
						const data = goalPeriodCopyResponse.data;
						if(data.users == null) data.users = [];

						Object.assign(target, data);
					}
				}catch(e) {
					catchError(e, true);
					router.push({ name: `company.admin.goal.period.index` });
				}finally {
					loading.value = false;
				}
			});

			return { loading, goal, isBefore, target, submit, submitting, validation, validationExternal };
		}
	}
</script>